<template>
  <div class="card content-crud">
    <div class="ibox" v-if="!$route.params.operation">
      <div class="ibox-title" style="padding: 16px">
        <h3>
          {{ crudName }}
          <router-link
            :to="endPoint + 'add'"
            class="btn btn-primary"
            v-show="enableAdd"
            style="float: right; margin-top: -5px"
            >{{ newText }}</router-link
          >
        </h3>
      </div>
      <div class="ibox-content">
        <div class="block m-b-md text-right" v-if="enableAddModal">
          <button type="button" class="btn btn-success" @click="addModal">
            Adicionar {{ crudName }}
          </button>
        </div>

        <v-server-table
          style="padding: 10px"
          ref="table"
          :tableData="tableData"
          :name="table"
          :url="url"
          :columns="columns"
          :options="options"
        >
          <div
            :slot="'filter__' + filter.name"
            v-for="filter in customFilters"
            :key="filter.name"
          >
            <template v-if="filter.type == 'calendar'">
              <input
                type="date"
                class="form-control"
                :name="filter.call"
                :id="filter.name"
                @change="filterChange(filter.call, filter.name)"
              />
            </template>
          </div>
          <div slot="actions" slot-scope="props">
            <button
              v-show="enableDouble"
              data-toggle="tooltip"
              title="Replicar"
              class="btn btn-crud key p-0 margin-crud"
              @click="double(props.row.id)"
            >
              <i class="fa fa-copy"></i>
            </button>
            <button
              v-show="enableDownload"
              data-toggle="tooltip"
              title="Download"
              class="btn btn-add btn-crud p-0 margin-crud"
              @click="download(props.row.file)"
            >
              <i class="fa fa-download"></i>
            </button>
            <button
              v-show="enableView"
              data-toggle="tooltip"
              title="Consultar"
              class="btn btn-crud view margin-crud"
              @click="view(props.row.id)"
            >
              <i
                class="fas fa-eye"
                data-toggle="tooltip"
                title="Visualizar"
              ></i>
            </button>
            <button
              v-show="enableEdit"
              data-toggle="tooltip"
              title="Editar"
              type="button"
              class="btn btn-crud edit margin-crud"
              @click="edit(props.row.id)"
            >
              <i
                class="fas fa-pencil-alt"
                data-toggle="tooltip"
                title="Editar"
              ></i>
            </button>
            <a
              v-show="enableEditModal"
              @click="editModal(props.row.id)"
              data-toggle="tooltip"
              title="Editar"
              class="btn btn-warning fa fa-pencil margin-crud"
            ></a>
            <button
              v-show="enableTickets"
              data-toggle="tooltip"
              title="Atender Chamado"
              class="btn btn-crud edit margin-crud"
              @click="ticket(props.row.id)"
            >
              <i
                class="fas fa-eye"
                data-toggle="tooltip"
                title="Visualizar"
              ></i>
            </button>
            <button
              v-show="enableDelete"
              data-toggle="tooltip"
              title="Deletar"
              type="button"
              class="btn btn-crud delete margin-crud"
              @click="destroy(props, props.row, props.index)"
            >
              <i
                class="far fa-trash-alt"
                data-toggle="tooltip"
                title="Excluir"
              ></i>
            </button>
            <button
              v-show="enableDeleteReasons"
              style="margin-right: 8px"
              class="btn btn-crud delete margin-crud"
              data-toggle="modal"
              data-target="#deletewithreasons"
              @click="selectLine(props, props.row, props.index)"
            >
              <i
                class="far fa-trash-alt"
                data-toggle="tooltip"
                title="Excluir"
              ></i>
            </button>
            <button
              v-show="enableReset"
              data-toggle="tooltip"
              title="Alterar Senha"
              class="btn btn-crud view key margin-crud"
              @click="resetpassword(props.row.id)"
            >
              <i
                class="fas fa-key"
                data-toggle="tooltip"
                title="Resetar Senha"
              ></i>
            </button>
            <template v-for="extra in extra">
              <button
                data-toggle="tooltip"
                :title="extra.title"
                :key="extra.id"
                :class="extra.class"
                @click="callExtra(extra.name, props, props.row, props.index)"
              >
                <i :class="extra.icon" v-if="extra.icon.length > 0"></i>
                {{ extra.label }}
              </button>
            </template>
          </div>
          <div slot="photo" slot-scope="props">
            <img :src="props.row.photo" alt class="photo" />
          </div>
          <div slot="cover_photo" slot-scope="props">
            <img :src="props.row.cover_photo" alt class="photo" />
          </div>
          <div slot="color" slot-scope="props">
            <div
              class="box"
              v-bind:style="{ 'background-color': props.row.color }"
            ></div>
            <span class="bold">{{ props.row.color }}</span>
          </div>
          <div slot="qrcode" slot-scope="props">
            <img :src="props.row.qrcode + ''" alt class="qrcode" />
            <br />
            <span class="bold">{{ props.row.qrcode_name }}</span>
          </div>
          <div slot="qrcodeid" slot-scope="props">
            <qrcode-vue
              class="code_crud"
              size="70"
              :value="
                props.row.qrcodeid ? props.row.qrcodeid + '' : props.row.id + ''
              "
              level="H"
            ></qrcode-vue>
          </div>
          <!--
            Repasse dinâmico: cada Crud.vue pode declarar slot="minhaColuna"
            no <base-crud> pra customizar a célula (ex: badge de status). Sem
            isso, o <slot></slot> abaixo só repassa o slot "default" - slots
            nomeados vindos de fora nunca chegavam na v-server-table, então
            toda coluna customizada (situacao/status/unidade/grupo/etc, em
            várias telas) ficava em branco ou mostrava o valor bruto.
          -->
          <template v-for="name in passthroughSlotNames" v-slot:[name]="slotProps">
            <slot :name="name" v-bind="slotProps"></slot>
          </template>
          <slot></slot>
        </v-server-table>
      </div>
    </div>
    <div
      class="modal fade"
      id="deletewithreasons"
      tabindex="-1"
      role="dialog"
      aria-labelledby="title"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="title">
              Escolha o motivo para Excluir!
            </h5>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-12">
                <label>Selecione o novo status</label>
                <v-select
                  v-model="reason"
                  :options="reasons"
                  :reduce="(reasons) => reasons.id"
                  :label="'title'"
                ></v-select>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Cancelar
            </button>
            <button
              type="button"
              class="btn btn-primary"
              data-dismiss="modal"
              @click="deleteWithReason()"
            >
              Salvar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Pagination } from "vue-pagination-2";
import { integer } from "@core/utils/validations/validations";
// import BaseForm from "./BaseForm";
// import QrcodeVue from "qrcode.vue";

export default {
  data: function () {
    return {
      records: [],
      pages: [],
      tableData: [],
      model: [],
      reasons: [],
      reason: integer,
      lineClick: integer,
    };
  },
  props: {
    crudName: String,
    fieldStatus: String,
    status: String,
    newText: String,
    table: String,
    customFilters: Array,
    columns: Array,
    options: Object,
    endPoint: String,
    with: String,
    enableAdd: Boolean,
    enableAddModal: Boolean,
    enableEditModal: Boolean,
    enableEdit: Boolean,
    enableDelete: Boolean,
    enableDeleteReasons: Boolean,
    enableView: Boolean,
    enableReset: Boolean,
    enableTickets: Boolean,
    enableDownload: Boolean,
    enableDouble: Boolean,
    extra: Array,
    dataForm: Object,
  },
  mounted() {
    this.enableAddModal = this.enableAddModal || false;
    this.enableEditModal = this.enableEditModal || false;
  },
  computed: {
    url() {
      return (
        this.$store.getters.api + this.endPoint + (this.with ? this.with : "")
      );
    },
    passthroughSlotNames() {
      const reservados = [
        "default",
        "actions",
        "photo",
        "cover_photo",
        "color",
        "qrcode",
        "qrcodeid",
      ];
      return Object.keys(this.$scopedSlots).filter(
        (nome) => !reservados.includes(nome) && !nome.startsWith("filter__")
      );
    },
  },
  methods: {
    filterChange(call, date) {
      let valor = $("#" + date).val();
      valor = valor.replace("T", " ");

      // console.log(valor)

      this.$emit(call, valor);
      this.$refs.table.refresh();
    },
    callExtra(name, props, row, index) {
      this.$emit(name, {
        props,
        row,
        index,
      });
    },
    double(id) {
      this.$router.push({
        path: this.endPoint + "double/" + id,
      });
    },
    edit(id) {
      this.$router.push({
        path: this.endPoint + "edit/" + id,
      });
    },
    resetpassword(id) {
      this.$router.push({
        path: this.endPoint + "resetpassword/" + id,
      });
    },
    view(id) {
      this.$router.push({
        path: this.endPoint + "view/" + id,
      });
    },
    ticket(id) {
      this.$router.push({
        path: this.endPoint + "ticket/" + id,
      });
    },
    download(file) {
      window.open(file, "_blank");
    },
    selectLine(props, row, index) {
      const self = this;
      self.lineClick = row.id;
    },
    destroy(props, row, index) {
      const self = this;
      swal({
        title: "Deseja deletar o registro?",
        text: "Essa operação não pode ser desfeita",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Sim, deletar!",
        showLoaderOnConfirm: true,
        buttons: {
          catch: {
            text: "Não",
            value: "cancel",
            className: "btn-danger",
          },
          confirm: {
            text: "Sim",
            value: "confirm",
          },
        },
      }).then((value) => {
        switch (value) {
          case "cancel":
            swal("Cancelado", "O registro não foi excluido!", "info");
            break;
          case "confirm":
            axios
              .delete(this.url + row.id, {
                id: row.id,
              })
              .then((response) => {
                self.$refs.table.data.splice(index - 1, 1);
                swal("Sucesso", "Registro excluído com sucesso!", "success");
                self.$refs.table.refresh();
              });
            break;
        }
      });
    },
    deleteWithReason() {
      const self = this;
      if (self.reason == undefined || self.reason == "" || self.reason == 0) {
        swal("Erro", "Selecione um motivo para excluir!", "error");
        return false;
      }
      swal({
        title: "Deseja deletar o registro?",
        text: "Essa operação não pode ser desfeita",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Sim, deletar!",
        showLoaderOnConfirm: true,
        buttons: {
          catch: {
            text: "Não",
            value: "cancel",
            className: "btn-danger",
          },
          confirm: {
            text: "Sim",
            value: "confirm",
          },
        },
      }).then((value) => {
        switch (value) {
          case "cancel":
            swal("Cancelado", "O registro não foi excluido!", "info");
            break;
          case "confirm":
            const api =
              self.$store.state.api + "log_reasons_delete_" + self.endPoint;
            let data = {};
            data.id_calls = self.lineClick;
            data.id_reasons_delete = self.reason;
            axios
              .post(api, data)
              .then((response) => {
                self.deleteRow(self.lineClick);
              })
              .catch((error) => {
                self.$message(null, error.response.data, "error");
              });
        }
      });
    },
    deleteRow(row) {
      const self = this;
      axios
        .delete(this.url + row, {
          id: row,
        })
        .then((response) => {
          //self.$refs.table.tableData.splice(index - 1, 1);
          swal("Sucesso", "Registro excluído com sucesso!", "success");
          self.$refs.table.refresh();
          this.show = false;
        });
    },
    getReasons: function () {
      const self = this;
      const api = self.$store.state.api + "reasons_delete_" + self.endPoint;
      axios
        .get(api)
        .then((response) => {
          self.reasons = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    addModal: function () {
      this.$emit("addModal");
    },
    editModal: function (id) {
      this.$emit("editModal", id);
    },
  },
  mounted: function () {
    const self = this;
    if (self._props.enableDeleteReasons == true) {
      self.getReasons();
    }
  },
  components: {
    Pagination,
  },
};
</script>

<style scoped>
.photo {
  max-height: 90px;
  max-width: 90px;
}
.key {
  border: 2px solid #ff7301;
  color: #000000;
}
.key:hover {
  background: #ff7301 !important;
  color: #ffffff;
}
.btn-add {
  color: black !important;
}
.btn-add:hover {
  color: #ffffff !important;
}
.margin-crud {
  margin: 0 2px;
}
</style>
